(function ($) {
    /* eslint-disable */
    /* global Swiper */

    $('.swiper-popular-no-container').each(function() {
        var $slider = $(this).closest('.slider');
        var popularSlider = new Swiper(this, {
            slidesPerView: 'auto',
            spaceBetween: 40,
            simulateTouch: false,
            allowTouchMove: false,
            navigation: {
                nextEl: $('.swiper-button-next', $slider).get(0),
                prevEl: $('.swiper-button-prev', $slider).get(0),
            },
            pagination: {
                el: $('.swiper-pagination', $slider).get(0),
                type: 'progressbar',
            },
        });
    });



    $('.swiper-popular-goods').each(function() {
        var $this = $(this);
        var $slider = $this.closest('.slider');
        $next =  $('.swiper-button-next', $slider);
        $prev =  $('.swiper-button-prev', $slider);

        var popularSliderSimple = new Swiper(this, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            simulateTouch: false,
            allowTouchMove: false,
            navigation: {
                nextEl: $next.get(0),
                prevEl: $prev.get(0),
            },
        });
    });

    $('.swiper-popular-products').each(function() {
        var $this = $(this);
        var $slider = $this.closest('.slider');
        $next =  $('.swiper-button-next', $slider);
        $prev =  $('.swiper-button-prev', $slider);

        var popularSliderSimple = new Swiper(this, {
            slidesPerView: 'auto',
            spaceBetween: 40,
            simulateTouch: false,
            allowTouchMove: false,
            navigation: {
                nextEl: $next.get(0),
                prevEl: $prev.get(0),
            },
        });
    });


    $('.swiper-popular-tools').each(function() {
        var $this = $(this);
        var $slider = $this.closest('.slider');
        $next =  $('.swiper-button-next', $slider);
        $prev =  $('.swiper-button-prev', $slider);

        var navigation = function() {
            var sliderLength = $('.swiper-slide', $slider).length;
            if (sliderLength <= 3) {
                $next.hide();
                $prev.hide();
                return false;
            }
            return {
                nextEl: $next.get(0),
                prevEl: $prev.get(0),
            }
        };


        var popularSliderSimple = new Swiper(this, {
            slidesPerView: 'auto',
            // spaceBetween: 45,
            simulateTouch: false,
            // allowTouchMove: false,
            navigation: navigation(),
        });

    });


    $('.swiper-popular-tool').each(function() {
        var $this = $(this);
        var $slider = $this.closest('.slider');
        $next =  $('.swiper-button-next', $slider);
        $prev =  $('.swiper-button-prev', $slider);

        var navigation = function() {
            var sliderLength = $('.swiper-slide', $slider).length;
            if (sliderLength <= 4) {
                $next.hide();
                $prev.hide();
                return false;
            }
            return {
                nextEl: $next.get(0),
                prevEl: $prev.get(0),
            }
        };


        var popularSliderSimple = new Swiper(this, {
            slidesPerView: 'auto',
            // spaceBetween: 45,
            simulateTouch: false,
            // allowTouchMove: false,
            navigation: navigation(),
        });

    });


})( jQuery );

